export default {
    "lyrics": [
        {
            "characters": ["startup"],
            "time": "00:01",
            "lyric": "Is that it? Is that the end?"
        },
        {
            "characters": ["startup"],
            "time": "00:03",
            "lyric": "But who's evil and who's the hero?"
        },
        {
            "characters": ["startup", "vc", "greg"],
            "time": "00:05",
            "lyric": "🤷‍♂️"
        },
        {
            "characters": ["vc"],
            "time": "00:18",
            "lyric": "Let me see your hands together"
        },
        {
            "characters": ["startup", "vc", "greg"],
            "time": "00:20",
            "lyric": "🤷‍♂️"
        },
        {
            "characters": ["startup", "vc", "greg"],
            "time": "00:22",
            "lyric": "Share The Valley on social media! :)"
        },
        {
            "characters": ["startup", "vc", "greg"],
            "time": "00:25",
            "lyric": "Thanks for listening :)"
        },
        {
            "characters": ["startup", "vc", "greg"],
            "time": "00:35",
            "lyric": "Talk to me on any of the social links below!"
        },
        {
            "characters": ["startup", "vc", "greg"],
            "time": "00:40",
            "lyric": "Only God Knows"
        },
        {
            "characters": ["startup", "vc", "greg"],
            "time": "00:45",
            "lyric": "🤷‍♂️"
        },
        {
            "characters": ["startup", "vc", "greg"],
            "time": "01:33",
            "lyric": "The Valley"
        },
    ]
}
